$(document).on("click",".styles_Shoes--SizeChangers .radio-switch__item",function(e) {
  var value = $(this).find('.radio-switch__label').data('id');
  
  if($(this).parents('.sidebar__filter__group').hasClass('active-eu')){
    $(this).parents('.sidebar__filter__group').removeClass('active-eu')
  }

  if($(this).parents('.sidebar__filter__group').hasClass('active-us')){
    $(this).parents('.sidebar__filter__group').removeClass('active-us')
  }
  
  $('.styles_Shoes--SizeChangers .radio-switch__item').removeClass('active');

  $(this).addClass('active');
  $(this).parents('.sidebar__filter__group').addClass('active-'+value+'');
  
  if(value == "us"){
    handleRadioButtonChanges("US")
  }else{
    handleRadioButtonChanges("EU")
  }
});

var sizesToConverts = document.querySelectorAll('.is_Size .sidebar__navigation__list .filter__button');

// Consolidated size details object with placeholders for settings
var sizeDetailss = {
  US: { 30: 12.5,
30.5: 13,
31: 13.5,
31.5: 1,
32: 1.5,
32.5: 2,
33: 2.5,
33.5: 3,
34: 3.5,
34.5: 4,
35: 4.5,
35.5: 3.5,
36: 4,
36.5: 4.5,
"36⅔": "4.5",
37: 4.5,
37.5: 5,
"37⅓": "5",
"38⅓": "5.5",
"38⅔": "5.5",
38: 5.5,
38.5: 6,
39: 6.5,
"39-41": "6-7.5",
"39⅓": "6.5",
39.5: 6.5,
40: 7,
40.5: 7.5,
"40⅔": "7.5",
"40½": "7.5",
41: 8,
"41⅓": "8",
41.5: 8,
42: 8.5,
"42-44": "8-10",
42.5: 9,
"42⅔": "9",
43: 9.5,
"43⅓": "9.5",
43.5: 9.5,
44: 10,
44.5: 10.5,
"44½": "10.5",
"44⅔": "10.5",
45: 11,
"45-47": "11-13",
45.5: 11.5,
"45⅓": "11.5",
46: 12,
46.5: 12,
"46⅔": "12.5",
47: 12.5,
"47⅓": "13",
47.5: 13,
"48½": "13.5",
"48⅔": "13.5",
48.5: 13.5,
48: 14,
"49⅓": "14.5",
49.5: 14.5,
50: 15 },
  USW: {  },
  UK: {  },
  CM: {  }
};
function handleRadioButtonChanges(sizeType) {
var sizesToConverts = document.querySelectorAll('.is_Size .sidebar__navigation__list .filter__button');
  
  sizesToConverts.forEach(sizeElement => {
    
    var originalValues = sizeElement.getAttribute('data-original-value');
    var convertedSizes = sizeType === 'EU' ? originalValues : convertSizes(originalValues, sizeType.replace(' ', ''));
    
    
    sizeElement.querySelector('.ValuesShouldChange').textContent = convertedSizes;
  });
}
function convertSizes(size, targetSizeType) {
  
  var hasFlightIcons = size.includes('⚡︎');
  var cleanedSizes = size.replace(/[⚡⚡︎]/g, '');
  var sizeMaps = sizeDetailss[targetSizeType];

  var convertedSizess = sizeMaps[cleanedSizes] || size;

  return hasFlightIcons ? `${convertedSizess} ⚡︎` : convertedSizess;
}


// $(document).on("keyup",".filter__button_search input.filter__button_search",function(event) {
//   // event.preventdefault();
//   event.stoppropagation();
//   debugger
// });
